<template>
  <div class="pagination">
    <a-pagination  :total="total" :current="current"  show-less-items :defaultPageSize="pageSize" :pageNum="pageNum"  @change="handlePagination"/>
  </div>
</template>

<script>
export default {
  name: 'AntdvPagination',
  //:total="total" :pageSize="queryVolleyParams.pageSize" :pageNum="queryVolleyParams.pageNum" v-if="total>scheduleList.length" @changePageNum="changePageNum"
  props: {
    total:{
        type:Number,
        default:0
    },
    pageSize:{
        type:Number,
        default:10
    },
    pageNum:{
        type:Number,
        default:1
    },
  },
  data() {
    return {
        current:1
    }
  },
  components: {},
  mounted() {},
  methods: {
    handlePagination(pageNum, pageSize){
        this.current=pageNum
        this.$emit('changePageNum',pageNum)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.pagination{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/public/AntdvPagination.vue